import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ApplicationDetailsState } from "../states/application-details.state";

export const selectApplicationDetailsState =
  createFeatureSelector<ApplicationDetailsState>("applicationDetails");

export const selectApplicationDetails = createSelector(
  selectApplicationDetailsState,
  (state) => state.applications
);

export const selectApplicationDetailsLoading = createSelector(
  selectApplicationDetailsState,
  (state) => state.loading
);

export const selectApplicationDetailsError = createSelector(
  selectApplicationDetailsState,
  (state) => state.error
);

export const selectSideNavDetails = createSelector(
  selectApplicationDetailsState,
  (state) => state.sideNavDetails
);
